import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=f0f238fe&scoped=true&"
import script from "./Test.vue?vue&type=script&lang=js&"
export * from "./Test.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=f0f238fe&prod&scoped=true&lang=css&"
import style1 from "./Test.vue?vue&type=style&index=1&id=f0f238fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f238fe",
  null
  
)

export default component.exports